import { GridColDef, GridRenderCellParams } from "@mui/x-data-grid-pro";
import { LineupApiResponse } from "../../postContest/queries/queryTypes";
import { Grid } from "@material-ui/core";
import React from 'react';

export const postContestUserDataGridHeaderConfig = (handleUserClick: (userName: string) => void): GridColDef[] => {
  const headers: GridColDef[] = [
  {
    field: 'user',
    headerName: 'User',
    flex: .20,
    headerAlign: 'left',
    renderCell: (params: GridRenderCellParams<LineupApiResponse>) => {
      return (
        <div onClick={() => handleUserClick(params.value)} style={{ cursor: 'pointer'}}>{params.value}</div>
      )
    }
  },
  {
    field: 'totalLineups',
    headerName: 'Total Lineups',
    flex: .15,
    headerAlign: 'left',
    type: 'number',
    align: 'left',
  },
  {
    field: 'dupesPerLineup',
    headerName: 'Dupes / Lineup',
    flex: .15,
    headerAlign: 'left',
    type: 'number',
    align: 'left',
  },
  {
    field: 'simLineupRoi',
    headerName: 'Sim Lineup ROI',
    flex: .1,
    headerAlign: 'left',
    type: 'number',
    align: 'left',
    valueParser(value, params) {
      return value / 100;
    },
    valueFormatter(params) {
      if (isNaN(params.value)) {
        return null
      }
      const percentage = (params.value * 100)?.toFixed(1);
      return percentage + '%';
    },
  },
  {
    field: 'simAverageFantasyPoints',
    headerName: 'Sim Avg FP',
    flex: .15,
    headerAlign: 'left',
    type: 'number',
    align: 'left',
  },
  {
    field: 'averageOwnershipSumPct',
    headerName: 'Avg Own Sum',
    flex: .15,
    headerAlign: 'left',
    type: 'number',
    align: 'left',
  },
];

return headers;
}
export const postContestUserWithActualResultsDataGridHeaderConfig = (handleUserClick: (userName: string) => void): GridColDef[] => {

  const headers: GridColDef[] = [
    {
      field: 'user',
      headerName: 'User',
      flex: .20,
      headerAlign: 'left',
      renderCell: (params: GridRenderCellParams<LineupApiResponse>) => {
        return (
          <div onClick={() => handleUserClick(params.value)} style={{ cursor: 'pointer'}}>{params.value}</div>
        )
      }
    },
    {
      field: 'totalLineups',
      headerName: 'Total Lineups',
      flex: .1,
      headerAlign: 'left',
      type: 'number',
      align: 'left',
    },
    {
      field: 'dupesPerLineup',
      headerName: 'Dupes / Lineup',
      flex: .1,
      headerAlign: 'left',
      align: 'left',
      type: 'number',
    },
    {
      field: 'simLineupRoi',
      headerName: 'Sim Lineup ROI',
      flex: .1,
      headerAlign: 'left',
      type: 'number',
      align: 'left',
      valueParser(value, params) {
        return value / 100;
      },
      valueFormatter(params) {
        if (isNaN(params.value)) {
          return null
        }
        const percentage = (params.value * 100)?.toFixed(1);
        return percentage + '%';
      },
    },
    {
      field: 'actualLineupRoi',
      headerName: 'Actual Lineup ROI',
      flex: .15,
      headerAlign: 'left',
      type: 'number',
      align: 'left',
      valueParser(value, params) {
        return value / 100;
      },
      valueFormatter(params) {
        if (isNaN(params.value)) {
          return null
        }
        const percentage = (params.value * 100)?.toFixed(1);
        return percentage + '%';
      },
    },
    {
      field: 'simAverageFantasyPoints',
      headerName: 'Sim Avg FP',
      flex: .1,
      headerAlign: 'left',
      type: 'number',
      align: 'left',
    },
    {
      field: 'actualAverageFantasyPoints',
      headerName: 'Actual FP',
      flex: .1,
      headerAlign: 'left',
      type: 'number',
      align: 'left',
    },
    {
      field: 'averageOwnershipSum',
      headerName: 'Avg Own Sum',
      flex: .1,
      headerAlign: 'left',
      type: 'number',
      align: 'left',
      valueParser(value, params) {
        return value / 100;
      },
      valueFormatter(params) {
        if (isNaN(params.value)) {
          return null
        }
        const percentage = (params.value * 100)?.toFixed(1);
        return percentage + '%';
      },
    },
  ];

  return headers;
}

export const postContestPlayerDataGridHeaderConfig: GridColDef[] = [
  {
    field: 'player',
    headerName: 'Player',
    flex: .25,
    headerAlign: 'left',
  },
  {
    field: 'position',
    headerName: 'Position',
    flex: 0.1,
    headerAlign: 'left'
  },
  {
    field: 'simPlayerRoi',
    headerName: 'Sim Player ROI',
    flex: .25,
    headerAlign: 'left',
    type: 'number',
    align: 'left',
    valueParser(value, params) {
      return value / 100;
    },
    valueFormatter(params) {
      if (isNaN(params.value)) {
        return null
      }
      const percentage = (params.value * 100)?.toFixed(1);
      return percentage + '%';
    },
  },
  {
    field: 'overallOwnership',
    headerName: 'Field own %',
    flex: .25,
    headerAlign: 'left',
    type: 'number',
    align: 'left',
    valueParser(value, params) {
      return value / 100;
    },
    valueFormatter(params) {
      if (isNaN(params.value)) {
        return null
      }
      const percentage = (params.value * 100)?.toFixed(1);
      return percentage + '%';
    },
  },
];
export const postContestPlayerWithActualResultsDataGridHeaderConfig: GridColDef[] = [
  {
    field: 'player',
    headerName: 'Player',
    flex: .25,
    headerAlign: 'left',
  },
  {
    field: 'position',
    headerName: 'Position',
    flex: 0.1,
    headerAlign: 'left'
  },
  {
    field: 'simPlayerRoi',
    headerName: 'Sim Player ROI',
    flex: .25,
    headerAlign: 'left',
    type: 'number',
    align: 'left',
    valueParser(value, params) {
      return value / 100;
    },
    valueFormatter(params) {
      if (isNaN(params.value)) {
        return null
      }
      const percentage = (params.value * 100)?.toFixed(1);
      return percentage + '%';
    },
  },
  {
    field: 'actualPlayerRoi',
    headerName: 'Actual Player ROI',
    flex: .25,
    headerAlign: 'left',
    type: 'number',
    align: 'left',
    valueParser(value, params) {
      return value / 100;
    },
    valueFormatter(params) {
      if (isNaN(params.value)) {
        return null
      }
      const percentage = (params.value * 100)?.toFixed(1);
      return percentage + '%';
    },
  },
  {
    field: 'overallOwnership',
    headerName: 'Field own %',
    flex: .25,
    headerAlign: 'left',
    type: 'number',
    align: 'left',
    valueParser(value, params) {
      return value / 100;
    },
    valueFormatter(params) {
      if (isNaN(params.value)) {
        return null
      }
      const percentage = (params.value * 100)?.toFixed(1);
      return percentage + '%';
    },
  },
];
export const postContestPlayerUserDataGridHeaderConfig = (user: string, opponent: string): GridColDef[] => {

  const headers: GridColDef[] = [
    {
      field: 'player',
      headerName: 'Player',
      flex: .20,
      headerAlign: 'left',
    },
    {
      field: 'position',
      headerName: 'Position',
      flex: 0.1,
      headerAlign: 'left'
    },
    {
      field: 'overallOwnership',
      headerName: 'Field own %',
      flex: .20,
      headerAlign: 'left',
      type: 'number',
      align: 'left',
      valueParser(value, params) {
        return value / 100;
      },
      valueFormatter(params) {
        if (isNaN(params.value)) {
          return null
        }
        const percentage = (params.value * 100)?.toFixed(1);
        return percentage + '%';
      },
    },
    {
      field: 'simPlayerRoi',
      headerName: 'Sim Player ROI',
      flex: .20,
      headerAlign: 'left',
      type: 'number',
      align: 'left',
      valueParser(value, params) {
        return value / 100;
      },
      valueFormatter(params) {
        if (isNaN(params.value)) {
          return null
        }
        const percentage = (params.value * 100)?.toFixed(1);
        return percentage + '%';
      },
    },
    {
      field: 'userPlayerRoi',
      headerName: `${user} Player ROI`,
      flex: .20,
      headerAlign: 'left',
      type: 'number',
      align: 'left',
      valueParser(value, params) {
        return value / 100;
      },
      valueFormatter(params) {
        if (isNaN(params.value)) {
          return null
        }
        const percentage = (params.value * 100)?.toFixed(1);
        return percentage + '%';
      },
    },
    {
      field: 'userOwnership',
      headerName: `${user} %`,
      flex: .20,
      headerAlign: 'left',
      type: 'number',
      align: 'left',
      valueParser(value, params) {
        return value / 100;
      },
      valueFormatter(params) {
        if (isNaN(params.value)) {
          return null
        }
        const percentage = (params.value * 100)?.toFixed(1);
        return percentage + '%';
      },
    },
  ];

  const oppHeaders: GridColDef[] = [
    {
      field: 'player',
      headerName: 'Player',
      flex: .20,
      headerAlign: 'left',
    },
    {
      field: 'overallOwnership',
      headerName: 'Field own %',
      flex: .20,
      headerAlign: 'left',
      type: 'number',
      align: 'left',
      valueParser(value, params) {
        return value / 100;
      },
      valueFormatter(params) {
        if (isNaN(params.value)) {
          return null
        }
        const percentage = (params.value * 100)?.toFixed(1);
        return percentage + '%';
      },
    },
    {
      field: 'simPlayerRoi',
      headerName: 'Average Player ROI',
      flex: .20,
      headerAlign: 'left',
      type: 'number',
      align: 'left',
      valueParser(value, params) {
        return value / 100;
      },
      valueFormatter(params) {
        if (isNaN(params.value)) {
          return null
        }
        const percentage = (params.value * 100)?.toFixed(1);
        return percentage + '%';
      },
    },
    {
      field: 'userPlayerRoi',
      headerName: `${user} Player ROI`,
      flex: .20,
      headerAlign: 'left',
      type: 'number',
      align: 'left',
      valueParser(value, params) {
        return value / 100;
      },
      valueFormatter(params) {
        if (isNaN(params.value)) {
          return null
        }
        const percentage = (params.value * 100)?.toFixed(1);
        return percentage + '%';
      },
    },
    {
      field: 'userOwnership',
      headerName: `${user} own %`,
      flex: .20,
      headerAlign: 'left',
      type: 'number',
      align: 'left',
      valueParser(value, params) {
        return value / 100;
      },
      valueFormatter(params) {
        if (isNaN(params.value)) {
          return null
        }
        const percentage = (params.value * 100)?.toFixed(1);
        return percentage + '%';
      },
    },
    {
      field: 'opponentOwnership',
      headerName: `${opponent} own %`,
      flex: .20,
      headerAlign: 'left',
      type: 'number',
      align: 'left',
      valueParser(value, params) {
        return value / 100;
      },
      valueFormatter(params) {
        if (isNaN(params.value)) {
          return null
        }
        const percentage = (params.value * 100)?.toFixed(1);
        return percentage + '%';
      },
    },
  ];

  return opponent ? oppHeaders : headers;
}
export const postContestPlayerUserWithActualResultsDataGridHeaderConfig = (user: string, opponent: string): GridColDef[] => {

  const headers: GridColDef[] = [
    {
      field: 'player',
      headerName: 'Player',
      flex: .20,
      headerAlign: 'left',
    },
    {
      field: 'position',
      headerName: 'Position',
      flex: 0.1,
      headerAlign: 'left'
    },
    {
      field: 'overallOwnership',
      headerName: 'Field own %',
      flex: .20,
      headerAlign: 'left',
      type: 'number',
      align: 'left',
      valueParser(value, params) {
        return value / 100;
      },
      valueFormatter(params) {
        if (isNaN(params.value)) {
          return null
        }
        const percentage = (params.value * 100)?.toFixed(1);
        return percentage + '%';
      },
    },
    {
      field: 'simPlayerRoi',
      headerName: 'Sim Player ROI',
      flex: .20,
      headerAlign: 'left',
      type: 'number',
      align: 'left',
      valueParser(value, params) {
        return value / 100;
      },
      valueFormatter(params) {
        if (isNaN(params.value)) {
          return null
        }
        const percentage = (params.value * 100)?.toFixed(1);
        return percentage + '%';
      },
    },
    {
      field: 'actualPlayerRoi',
      headerName: 'Actual Player ROI',
      flex: .20,
      headerAlign: 'left',
      type: 'number',
      align: 'left',
      valueParser(value, params) {
        return value / 100;
      },
      valueFormatter(params) {
        if (isNaN(params.value)) {
          return null
        }
        const percentage = (params.value * 100)?.toFixed(1);
        return percentage + '%';
      },
    },
    {
      field: 'userPlayerRoi',
      headerName: `${user} Player ROI`,
      flex: .20,
      headerAlign: 'left',
      type: 'number',
      align: 'left',
      valueParser(value, params) {
        return value / 100;
      },
      valueFormatter(params) {
        if (isNaN(params.value)) {
          return null
        }
        const percentage = (params.value * 100)?.toFixed(1);
        return percentage + '%';
      },
    },
    {
      field: 'userOwnership',
      headerName: `${user} %`,
      flex: .20,
      headerAlign: 'left',
      type: 'number',
      align: 'left',
      valueParser(value, params) {
        return value / 100;
      },
      valueFormatter(params) {
        if (isNaN(params.value)) {
          return null
        }
        const percentage = (params.value * 100)?.toFixed(1);
        return percentage + '%';
      },
    },
  ];

  const oppHeaders: GridColDef[] = [
    {
      field: 'player',
      headerName: 'Player',
      flex: .20,
      headerAlign: 'left',
    },
    {
      field: 'position',
      headerName: 'Position',
      flex: 0.1,
      headerAlign: 'left'
    },
    {
      field: 'overallOwnership',
      headerName: 'Field own %',
      flex: .20,
      headerAlign: 'left',
      type: 'number',
      align: 'left',
      valueParser(value, params) {
        return value / 100;
      },
      valueFormatter(params) {
        if (isNaN(params.value)) {
          return null
        }
        const percentage = (params.value * 100)?.toFixed(1);
        return percentage + '%';
      },
    },
    {
      field: 'simPlayerRoi',
      headerName: 'Sim Player ROI',
      flex: .20,
      headerAlign: 'left',
      type: 'number',
      align: 'left',
      valueParser(value, params) {
        return value / 100;
      },
      valueFormatter(params) {
        if (isNaN(params.value)) {
          return null
        }
        const percentage = (params.value * 100)?.toFixed(1);
        return percentage + '%';
      },
    },
    {
      field: 'actualPlayerRoi',
      headerName: 'Actual Player ROI',
      flex: .20,
      headerAlign: 'left',
      type: 'number',
      align: 'left',
      valueParser(value, params) {
        return value / 100;
      },
      valueFormatter(params) {
        if (isNaN(params.value)) {
          return null
        }
        const percentage = (params.value * 100)?.toFixed(1);
        return percentage + '%';
      },
    },
    {
      field: 'userPlayerRoi',
      headerName: `${user} Player ROI`,
      flex: .20,
      headerAlign: 'left',
      type: 'number',
      align: 'left',
      valueParser(value, params) {
        return value / 100;
      },
      valueFormatter(params) {
        if (isNaN(params.value)) {
          return null
        }
        const percentage = (params.value * 100)?.toFixed(1);
        return percentage + '%';
      },
    },
    {
      field: 'userOwnership',
      headerName: `${user} own %`,
      flex: .20,
      headerAlign: 'left',
      type: 'number',
      align: 'left',
      valueParser(value, params) {
        return value / 100;
      },
      valueFormatter(params) {
        if (isNaN(params.value)) {
          return null
        }
        const percentage = (params.value * 100)?.toFixed(1);
        return percentage + '%';
      },
    },
    {
      field: 'opponentOwnership',
      headerName: `${opponent} own %`,
      flex: .20,
      headerAlign: 'left',
      type: 'number',
      align: 'left',
      valueParser(value, params) {
        return value / 100;
      },
      valueFormatter(params) {
        if (isNaN(params.value)) {
          return null
        }
        const percentage = (params.value * 100)?.toFixed(1);
        return percentage + '%';
      },
    },
  ];

  return opponent ? oppHeaders : headers;
}
export const postContestStackDataGridHeaderConfig: GridColDef[] = [
  {
    field: 'teamName',
    headerName: 'Team',
    flex: .20,
    headerAlign: 'left',
  },
  {
    field: 'simRoi3Man',
    headerName: '3 man Stack ROI',
    flex: .16,
    headerAlign: 'left',
    type: 'number',
    align: 'left',
    valueParser(value, params) {
      return value / 100;
    },
    valueFormatter(params) {
      if (isNaN(params.value)) {
        return null
      }
      const percentage = (params.value * 100)?.toFixed(1);
      return percentage + '%';
    },
  },
  {
    field: 'simRoi4Man',
    headerName: '4 man Stack ROI',
    flex: .16,
    headerAlign: 'left',
    type: 'number',
    align: 'left',
    valueParser(value, params) {
      return value / 100;
    },
    valueFormatter(params) {
      if (isNaN(params.value)) {
        return null
      }
      const percentage = (params.value * 100)?.toFixed(1);
      return percentage + '%';
    },
  },
  {
    field: 'simRoi5Man',
    headerName: '5 man Stack ROI',
    flex: .16,
    headerAlign: 'left',
    type: 'number',
    align: 'left',
    valueParser(value, params) {
      return value / 100;
    },
    valueFormatter(params) {
      if (isNaN(params.value)) {
        return null
      }
      const percentage = (params.value * 100)?.toFixed(1);
      return percentage + '%';
    },
  },
];

export const postContestStackTypeDataGridHeaderConfig: GridColDef[] = [
  {
    field: 'stackType',
    headerName: 'StackType',
    flex: .20,
    headerAlign: 'left',
  },
  {
    field: 'actualRoi',
    headerName: 'Actual ROI',
    flex: .16,
    headerAlign: 'left',
    type: 'number',
    align: 'left',
    valueParser(value, params) {
      return value / 100;
    },
    valueFormatter(params) {
      if (isNaN(params.value)) {
        return null
      }
      const percentage = (params.value * 100)?.toFixed(1);
      return percentage + '%';
    },
  },
  {
    field: 'count',
    headerName: 'Count',
    flex: .16,
    headerAlign: 'left',
    type: 'number',
    align: 'left',
  },
]
export const postContestLineupDataGridHeaderConfig: GridColDef[] = [
  {
    field: 'user',
    headerName: 'User',
    flex: .1,
    headerAlign: 'left',
  },
  {
    field: 'simLineupRoi',
    headerName: 'Sim Lineup ROI',
    flex: .1,
    headerAlign: 'left',
    type: 'number',
    align: 'left',
    valueParser(value, params) {
      return value / 100;
    },
    valueFormatter(params) {
      if (isNaN(params.value)) {
        return null
      }
      const percentage = (params.value * 100)?.toFixed(1);
      return percentage + '%';
    },
  },
  {
    field: 'simAverageFantasyPoints',
    headerName: 'Sim Avg FP',
    flex: .1,
    headerAlign: 'left',
    type: 'number',
    align: 'left',
  },
  {
    field: 'ownershipSum',
    headerName: 'OwnSum',
    flex: .1,
    headerAlign: 'left',
    type: 'number',
    align: 'left',
    valueParser(value, params) {
      return value / 100;
    },
    valueFormatter(params) {
      if (isNaN(params.value)) {
        return null
      }
      const percentage = (params.value * 100)?.toFixed(1);
      return percentage + '%';
    },
  },
  {
    field: 'duplicates',
    headerName: 'Duplicates',
    flex: .1,
    headerAlign: 'left',
    type: 'number',
    align: 'left',
  },
  {
    field: 'salary',
    headerName: 'Salary',
    flex: .1,
    headerAlign: 'left',
    type: 'number',
    align: 'left',
  },
  {
    field: 'fullLineup',
    headerName: 'Lineups',
    flex: .5,
    headerAlign: 'left',
    type: 'number',
    align: 'left',
    renderCell: (params: GridRenderCellParams<LineupApiResponse>) => {
      return (
        <Grid container justifyContent="space-between" style={{ padding: 2, fontSize: '16px', }}>
          <Grid item style={{ whiteSpace: 'break-spaces', fontSize: '12px' }}>
            {params.value}
          </Grid>
        </Grid>
      )
    }
  },
];
export const postContestLineupWithActualResultsDataGridHeaderConfig: GridColDef[] = [
  {
    field: 'user',
    headerName: 'User',
    flex: .08,
    headerAlign: 'left',
  },
  {
    field: 'simLineupRoi',
    headerName: 'Sim Lineup ROI',
    flex: .08,
    headerAlign: 'left',
    type: 'number',
    align: 'left',
    valueParser(value, params) {
      return value / 100;
    },
    valueFormatter(params) {
      if (isNaN(params.value)) {
        return null
      }
      const percentage = (params.value * 100)?.toFixed(1);
      return percentage + '%';
    },
  },
  {
    field: 'actualLineupRoi',
    headerName: 'Actual Lineup ROI',
    flex: .08,
    headerAlign: 'left',
    type: 'number',
    align: 'left',
    valueParser(value, params) {
      return value / 100;
    },
    valueFormatter(params) {
      if (isNaN(params.value)) {
        return null
      }
      const percentage = (params.value * 100)?.toFixed(1);
      return percentage + '%';
    },
  },
  {
    field: 'simAverageFantasyPoints',
    headerName: 'Sim Avg FP',
    flex: .08,
    headerAlign: 'left',
    type: 'number',
    align: 'left',
  },
  {
    field: 'actualFantasyPoints',
    headerName: 'Actual FP',
    flex: .08,
    headerAlign: 'left',
    type: 'number',
    align: 'left',
  },
  {
    field: 'ownershipSum',
    headerName: 'OwnSum',
    flex: .08,
    headerAlign: 'left',
    type: 'number',
    align: 'left',
    valueParser(value, params) {
      return value / 100;
    },
    valueFormatter(params) {
      if (isNaN(params.value)) {
        return null
      }
      const percentage = (params.value * 100)?.toFixed(1);
      return percentage + '%';
    },
  },
  {
    field: 'actualFinishPosition',
    headerName: 'Actual Finish Position',
    flex: .08,
    headerAlign: 'left',
    type: 'number',
    align: 'left',
  },
  {
    field: 'duplicates',
    headerName: 'Duplicates',
    flex: .08,
    headerAlign: 'left',
    type: 'number',
    align: 'left',
  },
  {
    field: 'salary',
    headerName: 'Salary',
    flex: .1,
    headerAlign: 'left',
    type: 'number',
    align: 'left',
  },
  {
    field: 'fullLineup',
    headerName: 'Lineups',
    flex: .35,
    headerAlign: 'left',
    renderCell: (params: GridRenderCellParams<LineupApiResponse>) => {
      return (
        <Grid container justifyContent="space-between" style={{ padding: 2, fontSize: '16px', }}>
          <Grid item style={{ whiteSpace: 'break-spaces', fontSize: '12px' }}>
            {params.value}
          </Grid>
        </Grid>
      )
    }
  },
];